<template>
  <div
    class="expandable-list-container"
    :class="{
      'expandable-list-container--expandable': isExpandable,
      'expandable-list-container--opened': isExpandable && isOpened,
      'expandable-list-container--closed': isExpandable && !isOpened,
    }"
  >
    <ul class="expandable-list">
      <li v-for="(item, index) in items" :key="index" class="expandable-list__item" data-test-id="expandable-list-item">
        <slot name="item" v-bind="{ item }" />
      </li>
    </ul>
    <button
      class="expandable-list__toggle"
      :aria-expanded="isOpened"
      :aria-label="isOpened ? 'Collapse list' : 'Expand list'"
      data-test-id="expandable-list-toggle"
      @click="toggleList"
    >
      <slot name="toggle" :opened="isOpened">
        <i
          :class="{
            'chevron-small-up-dark-medium': isOpened,
            'chevron-small-down-dark-medium': !isOpened,
          }"
          data-test-id="expandable-list-toggle-icon"
        ></i>
      </slot>
    </button>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';

const isOpened = ref(false);

const { items } = defineProps<{
  items: unknown[];
}>();

const isExpandable = computed(() => items.length > 1);

function toggleList() {
  if (!isExpandable.value) return;
  isOpened.value = !isOpened.value;
}
</script>

<style scoped lang="scss">
@import '~settingSCSS';
@import '@csgIcons/new/_chevron-small-up-dark-medium.scss';
@import '@csgIcons/new/_chevron-small-down-dark-medium.scss';

.expandable-list-container {
  position: relative;
  width: 100%;
  @include margin-bottom-s;
}

.expandable-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.expandable-list__toggle {
  display: none;
}

.expandable-list-container--expandable {
  .expandable-list__toggle {
    display: block;
  }

  &.expandable-list-container--opened {
    .expandable-list__item {
      display: block;

      &:not(:last-child) {
        @include margin-bottom-xxs;
      }
    }
  }

  &.expandable-list-container--closed {
    .expandable-list__item {
      &:not(:first-child) {
        display: none;
      }
    }
  }
}
</style>


